/**
 * Sawyer 08 meds-feeding (G3) — the Pet Profile's "Edit meds & feeding"
 * button and the sheet it opens, as one self-contained piece so the profile
 * page only places it (inside its Medications section) and nothing else.
 * The permission is read here: the button renders only for roles holding
 * `pets.meds-feeding:write:all` (owner, manager, receptionist, kennel_tech),
 * never an affordance the server would 403 (#484).
 */
import { useState } from 'react';
import { readSession } from '../../lib/api.js';
import { effectiveRolesOf, rolesHavePermission } from '../../lib/rbac-matrix.js';
import { MedsFeedingEditor, type EditorDog } from './MedsFeedingEditor.js';

export function MedsFeedingProfileAction({
  apiUrl,
  dog,
  onChanged,
}: {
  apiUrl: string;
  dog: EditorDog;
  /** Quiet profile re-read after a save. */
  onChanged: () => void;
}): JSX.Element | null {
  const [open, setOpen] = useState(false);
  const canEdit = rolesHavePermission(effectiveRolesOf(readSession().staff), 'pets.meds-feeding:write:all');
  if (!canEdit) return null;
  return (
    <>
      <button
        type="button"
        className="ferro-dogprofile__btn ferro-dogprofile__btn--ghost"
        onClick={() => setOpen(true)}
        data-testid="dogprofile-edit-meds-feeding"
      >
        Edit meds &amp; feeding
      </button>
      {open ? <MedsFeedingEditor apiUrl={apiUrl} dog={dog} onClose={() => setOpen(false)} onChanged={onChanged} /> : null}
    </>
  );
}
